var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCompanyTypeDistributor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73.873,
    height: 48.459,
    viewBox: "0 0 73.873 48.459",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "company_type_distributor_clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3579",
    "data-name": "Rectangle 3579",
    width: 73.873,
    height: 48.459,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3328",
    "data-name": "Group 3328",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3220",
    "data-name": "Group 3220",
    transform: "translate(0 0)",
    clipPath: "url(#company_type_distributor_clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3493",
    "data-name": "Path 3493",
    d: "M8.685,56.445H1.653A.655.655,0,0,0,1,57.1v2.62a.653.653,0,0,0,.653.657H7.577",
    transform: "translate(-0.357 -20.123)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3494",
    "data-name": "Path 3494",
    d: "M61.5,56.445H33",
    transform: "translate(-11.763 -20.123)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3495",
    "data-name": "Path 3495",
    d: "M99.072,60.379H107.9a.653.653,0,0,0,.653-.657V57.1a.656.656,0,0,0-.653-.657h-1.423",
    transform: "translate(-35.319 -20.123)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_565",
    "data-name": "Line 565",
    x1: 26.295,
    transform: "translate(22.337 40.256)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3496",
    "data-name": "Path 3496",
    d: "M86.909,40.674h8.346V38.98c0-5.682-.725-6.979-1.964-9.835C90.5,22.723,85.775,12.207,79.519,12.207H67.6V40.674h5.93",
    transform: "translate(-24.101 -4.352)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3497",
    "data-name": "Path 3497",
    d: "M9.556,36.679H4.224V1H45.008V36.679H22.739",
    transform: "translate(-1.506 -0.357)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3498",
    "data-name": "Path 3498",
    d: "M75.577,18.363V31.23H91.542S87.388,18.363,81.487,18.363Z",
    transform: "translate(-26.943 -6.547)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3499",
    "data-name": "Path 3499",
    d: "M75.577,58.371a7.559,7.559,0,1,1,7.559,7.559A7.558,7.558,0,0,1,75.577,58.371Z",
    transform: "translate(-26.943 -18.115)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3500",
    "data-name": "Path 3500",
    d: "M87.765,62.011a.989.989,0,1,1-.99-.989.989.989,0,0,1,.99.989",
    transform: "translate(-30.583 -21.755)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3501",
    "data-name": "Path 3501",
    d: "M11.22,58.371a7.559,7.559,0,1,1,7.559,7.559A7.558,7.558,0,0,1,11.22,58.371Z",
    transform: "translate(-4 -18.115)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3502",
    "data-name": "Path 3502",
    d: "M23.408,62.011a.989.989,0,1,1-.99-.989.989.989,0,0,1,.99.989",
    transform: "translate(-7.64 -21.755)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3575",
    "data-name": "Rectangle 3575",
    width: 15.681,
    height: 15.562,
    transform: "translate(10.257 7.856)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3576",
    "data-name": "Rectangle 3576",
    width: 3.424,
    height: 5.046,
    transform: "translate(16.385 7.855)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3577",
    "data-name": "Rectangle 3577",
    width: 10.026,
    height: 10.716,
    transform: "translate(25.938 12.702)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompanyTypeDistributor);
export default __webpack_public_path__ + "static/media/company_type_distributor.4961ed57.svg";
export { ForwardRef as ReactComponent };